module.exports = __webpack_public_path__ + "static/0001-5d87bde2ff69b748c15b3f06af307526.png";